AppTabs.createTab( {

name: 'view-data',
icon: 'clipboard-list',
text: 'View Data',
//preload: 'vmViewData',
actionElementClasses: [ 'view-project-data-link' ],
create: function(init) {
	'use strict'

	const fields = [
		{
			label: 		'Sample #',
			columnName: 'SampleNumber',
			order:		'desc',
			type:       'sample-link',
		},
		{
			label: 		'Sample ID',
			columnName:	'SampleDescription',
			type:       'sample-link',
		},
		{
			label: 		'Sample From Date',
			columnName: 'SampleFromDate',
			type:       'date',
		},
		{
			label: 		'Sample To Date',
			columnName: 'SampleToDate',
			type:       'date',
		},
		{
			label: 		'Login Date',
			columnName: 'LoginDate',
			type:       'date',
		},
		{
			label: 		'Test',
			columnName: 'TestName'
		},
		{
			label: 		'Analyte',
			columnName: 'Analyte'
		},
		{
			label: 		'QA Code',
			columnName: 'QAFlag'
		},
		{
			label: 		'Result',
			columnName: 'Result'
		},
		{
			label: 		'Units',
			columnName: 'Units'
		},
		{
			label: 		'Method',
			columnName: 'Method'
		},
		{
			label: 		'Analyst',
			columnName: 'Analyst',
		},
		{
			label: 		'Analyzed Date',
			columnName: 'AnalyzedDate',
			type:       'date',
		},
		{
			label: 		'Analyzed Time',
			columnName: 'AnalyzedTime',
		},
		{
			label: 		'Project #',
			columnName: 'ProjectNumber',
			type:       'project-link',
		},
		{
			label: 		'Client',
			columnName: 'ClientName',
			type:       'client-link',
		},
		{
			label: 		'Barcode',
			columnName: 'Barcode',
		},
		{
			label:		'Reported',
			columnName:	'ReportedDate',
			type:       'date',
		},
		{
			label:		'Location',
			columnName:	'Location',
		}
	];

	const tab = this;
	init.setDataTableArgs( {

		tableId: 		'#data-table-view-data',

		// tables used by DataTables actions
		// complex queries hardcoded in ajax actions

		primaryKey: 	'JobID',

		hasColumnFilters: 	false,
		canSearch: 			false,
		canSort:			true,
		drawWhen:           false,

		// Ajax action endpoints
		// these also serve as flags as to whether to show the editor buttons or add the autofill eventListener
		actionData:			'datatable_view_data',
		//actionAutofill:	'datatable_autofill_view_data',
		//actionCreate:		'datatable_create_view_data',
		//actionEdit:		'datatable_edit_view_data',
		//actionRemove:		'datatable_remove_view_data',
		actionPrint:        true,

		// Adds additional data fields to ajax requests when drawing the table
		ajaxDataCallback : function( data, settings ) {
			const vmViewData        = tab.controller;
			data.testID 			= vmViewData && vmViewData.test 		? vmViewData.test.id 	: -1;
			data.clientID 			= vmViewData && vmViewData.client 	? vmViewData.client.id 	: -1;
			data.projectName		= vmViewData.projectName;
			data.projectNumber		= vmViewData && vmViewData.projectNumber !== undefined ? vmViewData.projectNumber : -1;
			data.sampleNumber 		= vmViewData.sampleNumber;
			data.loginDateFrom 		= vmViewData.loginDateFrom;
			data.loginDateTo 		= vmViewData.loginDateTo;
			data.hasResults			= vmViewData.hasResults;
			data.metals 			= vmViewData.metals;
			console.log( { vmViewData, tab, data } );
			return data;
		},

		fields: fields,

	} );

	init.setController( new TabControllerVue({
		el: '#view-data-datatable-filters',
		computed: {
			clients: function() {
				return LocalStorageManager.get( 'clientList' );
			},
			tests: function() {
				return LocalStorageManager.get( 'testList' );
			},
		},
		methods: {
			resetData() {
				this.test           = null;
				this.client         = null;
				this.projectName    = null;
				this.projectNames   = [];
				this.projectNumber  = null;
				this.projectNumbers = [];
				this.sampleNumber   = null;
				this.sampleNumbers  = [];
				this.loginDateFrom  = null;
				this.loginDateTo    = null;
				this.metals         = -1;
				this.hasResults     = -1;

				this.fetchingProjectNames   = false;
				this.fetchingSampleNumbers  = false;
				this.fetchingProjectNumbers = false;
			},
			onOpenTab: function() {
				this.ajaxLoadProjectNames();
				this.ajaxLoadProjectNumbers();
				this.ajaxLoadSampleNumbers();
			},
			ajaxLoadProjectNames(prefix = '') {
				const _this = this;
				_this.fetchingProjectNames = false;

				window.ajaxCall({
					data : {
						action: 'get_project_names_by_client',
						clientId: this.client ? this.client.id : null,
						prefix,
					},
					onSuccess( response ) {
						if ((response.data && response.data.length) || !prefix) {
							_this.projectNames = response.data;
							_this.fetchingProjectNames = false;
						} else
							_this.ajaxLoadProjectNames();
					},
					onError( response ) {
						_this.fetchingProjectNames = false;
						alert( _this.client
							? 'Could not load Project Names for ' + _this.client.text
							: 'Could not load Project Names' );
					},
				});
			},
			ajaxLoadProjectNumbers(prefix = '') {
				if ( ! this.client ) {
					this.projectNumbers = ['loading...'];
				}
				const _this = this;
				_this.fetchingProjectNumbers = true;

				window.ajaxCall({
					data : {
						action: 'get_project_numbers_by_client',
						clientId: this.client ? this.client.id : null,
						prefix,
					},
					onSuccess( response ) {
						if ((response.data && response.data.length) || !prefix) {
							_this.projectNumbers = response.data;
							_this.fetchingProjectNumbers = false;
						} else
							_this.ajaxLoadProjectNumbers();
					},
					onError( response ) {
						_this.fetchingProjectNumbers = false;
						alert( _this.client
							? 'Could not load Project Numbers for ' + _this.client.text
							: 'Could not load Project Numbers' );
					},
				});
			},
			ajaxLoadSampleNumbers(prefix = '') {
				if ( ! this.client ) {
					this.sampleNumbers = ['loading...'];
				}
				const _this = this;
				_this.fetchingSampleNumbers = true;

				window.ajaxCall({
					data : {
						action: 'get_sample_numbers_by_client',
						clientId: this.client ? this.client.id : null,
						prefix,
					},
					onSuccess( response ) {
						if ((response.data && response.data.length) || !prefix) {
							_this.sampleNumbers = response.data;
							_this.fetchingSampleNumbers = false;
						} else {
							_this.ajaxLoadSampleNumbers();
						}
					},
					onError( response ) {
						_this.fetchingSampleNumbers = false;
						alert( _this.client
							? 'Could not load Sample Numbers for ' + _this.client.text
							: 'Could not load Sample Numbers' );
					},
				});
			},

			doElementAction: function(target, elClass, event) {
				this.projectNumber = target.dataset.jobNumber;
				tab.showAll();
			},
			search() { tab.drawTable(); },
		},
		watch: {
			client: function( newValue, oldValue ) {
				console.log('watch client', newValue, oldValue);
				this.projectName = null;
				this.projectNames = [];
				this.projectNumber = null;
				this.projectNumbers = [];
				this.sampleNumber = null;
				this.sampleNumbers = [];
				this.ajaxLoadProjectNames();
				this.ajaxLoadProjectNumbers();
				this.ajaxLoadSampleNumbers();
			}
		}
	}) );

}

} );
